import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchTerminals} from '../actions/terminal'
import {changeFilterDatas} from '../actions/filter'
import Terminal from '../components/Terminal'

const mapStateToProps = state => {
  const { terminal} = state
  const {
    isFetching,
    lastUpdated,
    items,
    // totalRows
  } = terminal || {
    isFetching: true,
    items: []
  }
  

  return {
    items,
    isFetching,
    lastUpdated,
    // totalRows,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTerminals: fetchTerminals,
      changeFilterDatas:changeFilterDatas,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Terminal)
